import React from 'react';
import { Checkbox } from '@onward-delivery/design';

import BadgeTag from './BadgeTag';
import { describeCarrierRow } from '../utils';

const CardBadge = ({ badge }) => <BadgeTag variant={badge.variant}>{badge.label}</BadgeTag>;

/**
 * One account's card in an onboarding tab: checkbox, name and subtitle, and badges. `describe` reads the row:
 * describeCarrierRow by default, describeShipperRow for shippers. With `onOpen`, the name is a button that opens the
 * account.
 *
 * @param {{ row: object, checked: boolean, onToggle: Function, onOpen?: Function, describe?: Function }} props
 */
const OnboardingRow = ({ row, checked, onToggle, onOpen, describe = describeCarrierRow }) => {
    const { id, name, subtitle, badges } = describe(row);

    return (
        <li className="flex items-center gap-3 rounded-[10px] border border-slate-200 bg-white px-3.5 py-3">
            <Checkbox checked={checked} onCheckedChange={() => onToggle(id)} aria-label={`Select ${name}`} />
            <div className="flex min-w-0 flex-1 flex-col">
                {onOpen ? (
                    <button
                        type="button"
                        onClick={() => onOpen(row)}
                        className="cursor-pointer truncate rounded-sm border-0 bg-transparent p-0 text-left text-[14px] font-semibold text-slate-900 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                    >
                        {name}
                    </button>
                ) : (
                    <span className="truncate text-[14px] font-semibold text-slate-900">{name}</span>
                )}
                <span className="truncate text-[12px] text-slate-500">{subtitle}</span>
            </div>
            <div className="flex shrink-0 flex-wrap items-center justify-end gap-1.5">
                {badges.map((badge) => (
                    <CardBadge key={badge.key} badge={badge} />
                ))}
            </div>
        </li>
    );
};

export default OnboardingRow;
